import { Configuration } from '@azure/msal-browser';

export const internalAuthConfig: Configuration = {
  auth: {
    clientId: '9a260360-f21c-4ce8-9007-6296e5f8d544',
    authority: 'https://login.microsoftonline.com/05cdf50c-1c89-4622-811d-8885a6d883d4',
    redirectUri: '/admin',
  },
};

export const loginRequest = {
    scopes: ["openid", "profile"], // Basic scopes for authentication
};
  